import React, { useEffect } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import {
	Box,
	Grid,
	Button,
	Container,
	useTheme,
	useMediaQuery,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Watermark } from 'antd';
import { useLocation } from 'react-router-dom';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import MNavbar from '../components/resuableComponents/Navbar/MobileNav/MNavbar';
const steps = ['Review', 'Travel Detail', 'Payment'];

const FlightConfirmDetailPage = () => {
	const location = useLocation();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	console.log('FlightConfirmDetailPage', location);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<>
			<Navbar />
			<MNavbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<Watermark content='Musafir Bazar'>
				<Box style={{ padding: 20 }}>
					<Stepper activeStep={2} alternativeLabel>
						{steps.map((label) => (
							<Step key={label}>
								<StepLabel
									sx={{
										'.MuiStepLabel-label': {},
									}}>
									{label}
								</StepLabel>
							</Step>
						))}
					</Stepper>
				</Box>
				<Container>
					<Grid container spacing={4}>
						<Grid item xs={12} lg={8}>
							{location?.state?.onward?.Supplier === 'TBO' &&
								location?.state?.onward?.Segments[0]?.map((i) => {
									return (
										<Box
											style={{
												boxShadow: '0 0 10px rgba(0,0,0,.3)',
												backgroundColor: '#FFF',
												marginTop: 20,
												// padding: 10,
											}}>
											<Box
												style={{
													backgroundColor: '#E1E1E1',
													color: 'rgba(0,0,0,.64)',
													padding: 10,
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
													}}>
													<img
														src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
														style={{ height: 35 }}
													/>
													<span style={{ fontSize: 14, marginLeft: 10 }}>
														{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
													</span>
												</Box>
												<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
											</Box>

											<Box
												style={{
													padding: 20,
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}>
												<Box>
													<Box
														style={{ display: 'flex', alignItems: 'center' }}>
														<h1 style={{ fontSize: matches ? 16 : 26 }}>
															{i.Origin.Airport.AirportCode}
														</h1>
														<span
															style={{
																fontSize: matches ? 16 : '24px',
																marginLeft: '12px',
															}}>
															{i.Origin.DepTime.split('T')[1]}
														</span>
													</Box>
													<Box>
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.DepTime.split('T')[0]}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.Airport.AirportName}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.Airport.CityName}
														</span>
													</Box>
												</Box>
												<Box>
													<Box
														style={{
															alignItems: 'center',
															textAlign: 'center',
														}}>
														<AccessTimeIcon />
														<h2>2hr 30mn</h2>
													</Box>
												</Box>
												<Box>
													<Box
														style={{
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'end',
														}}>
														<h1 style={{ fontSize: matches ? 16 : 26 }}>
															{i.Destination.Airport.AirportCode}
														</h1>
														<span
															style={{
																fontSize: matches ? 16 : '24px',
																marginLeft: '12px',
															}}>
															{i.Destination.ArrTime.split('T')[1]}
														</span>
													</Box>
													<Box style={{ textAlign: 'end' }}>
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination.ArrTime.split('T')[0]}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination.Airport.AirportName}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination.Airport.CityName}
														</span>
													</Box>
												</Box>
											</Box>
											<Box
												style={{
													backgroundColor: '#E1E1E1',
													color: 'rgba(0,0,0,.64)',
													padding: 10,
													display: 'flex',
													justifyContent: 'space-between',
												}}>
												<Box>
													<span style={{ fontSize: 14 }}>BAGGAGE</span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
												</Box>
												<Box>
													<span style={{ fontSize: 14 }}>CHECK-IN </span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.Baggage}`}</span>
												</Box>
												<Box>
													<span style={{ fontSize: 14 }}>CABIN</span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.CabinBaggage}`}</span>
												</Box>
											</Box>
										</Box>
									);
								})}
							{location?.state?.onward?.Supplier === 'TBO' &&
								location?.state?.onward?.Segments.length > 1 &&
								location?.state?.onward?.Segments[1]?.map((i) => {
									return (
										<Box
											style={{
												boxShadow: '0 0 10px rgba(0,0,0,.3)',
												backgroundColor: '#FFF',
												marginTop: 20,
												// padding: 10,
											}}>
											<Box
												style={{
													backgroundColor: '#E1E1E1',
													color: 'rgba(0,0,0,.64)',
													padding: 10,
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
													}}>
													<img
														src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
														style={{ height: 35 }}
													/>
													<span style={{ fontSize: 14, marginLeft: 10 }}>
														{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
													</span>
												</Box>
												<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
											</Box>

											<Box
												style={{
													padding: 20,
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}>
												<Box>
													<Box
														style={{ display: 'flex', alignItems: 'center' }}>
														<h1 style={{ fontSize: 26 }}>
															{i.Origin.Airport.AirportCode}
														</h1>
														<span
															style={{ fontSize: '24px', marginLeft: '12px' }}>
															{i.Origin.DepTime.split('T')[1]}
														</span>
													</Box>
													<Box>
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.DepTime.split('T')[0]}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.Airport.AirportName}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.Airport.CityName}
														</span>
													</Box>
												</Box>
												<Box>
													<Box
														style={{
															alignItems: 'center',
															textAlign: 'center',
														}}>
														<AccessTimeIcon />
														<h2>2hr 30mn</h2>
													</Box>
												</Box>
												<Box>
													<Box
														style={{
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'end',
														}}>
														<h1 style={{ fontSize: 26 }}>
															{i.Destination.Airport.AirportCode}
														</h1>
														<span
															style={{ fontSize: '24px', marginLeft: '12px' }}>
															{i.Destination.ArrTime.split('T')[1]}
														</span>
													</Box>
													<Box style={{ textAlign: 'end' }}>
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination.ArrTime.split('T')[0]}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination.Airport.AirportName}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination.Airport.CityName}
														</span>
													</Box>
												</Box>
											</Box>
											<Box
												style={{
													backgroundColor: '#E1E1E1',
													color: 'rgba(0,0,0,.64)',
													padding: 10,
													display: 'flex',
													justifyContent: 'space-between',
												}}>
												<Box>
													<span style={{ fontSize: 14 }}>BAGGAGE</span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
												</Box>
												<Box>
													<span style={{ fontSize: 14 }}>CHECK-IN </span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.Baggage}`}</span>
												</Box>
												<Box>
													<span style={{ fontSize: 14 }}>CABIN</span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.CabinBaggage}`}</span>
												</Box>
											</Box>
										</Box>
									);
								})}
							{location?.state?.onward?.Supplier === 'ETR' &&
								location?.state?.onward?.Segments?.map((i) => {
									return (
										<Box
											style={{
												boxShadow: '0 0 10px rgba(0,0,0,.3)',
												backgroundColor: '#FFF',
												marginTop: 20,
												// padding: 10,
											}}>
											<Box
												style={{
													backgroundColor: '#E1E1E1',
													color: 'rgba(0,0,0,.64)',
													padding: 10,
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
													}}>
													<img
														src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
														style={{ height: 35 }}
													/>
													<span style={{ fontSize: 14, marginLeft: 10 }}>
														{`${i.Airline_Name} ${i.Airline_Code}-${i.Flight_Number}`}
													</span>
												</Box>
												<span>{`${i.Origin_City} to ${i.Destination_City}`}</span>
											</Box>

											<Box
												style={{
													padding: 20,
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
												}}>
												<Box>
													<Box
														style={{ display: 'flex', alignItems: 'center' }}>
														<h1>{i.Origin}</h1>
														<span
															style={{ fontSize: '24px', marginLeft: '12px' }}>
															{i.Departure_DateTime.split(' ')[1]}
														</span>
													</Box>
													<Box>
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Departure_DateTime.split(' ')[0]}
														</span>
														<br />
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Origin.Origin_City}
														</span>
													</Box>
												</Box>
												<Box>
													<Box
														style={{
															alignItems: 'center',
															textAlign: 'center',
														}}>
														<AccessTimeIcon />
														<h2>2hr 30mn</h2>
													</Box>
												</Box>
												<Box>
													<Box
														style={{
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'end',
														}}>
														<h1>{i.Destination}</h1>
														<span
															style={{ fontSize: '24px', marginLeft: '12px' }}>
															{i.Arrival_DateTime.split(' ')[1]}
														</span>
													</Box>
													<Box style={{ textAlign: 'end' }}>
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Arrival_DateTime.split(' ')[0]}
														</span>
														<br />
														<span style={{ fontSize: 12, color: 'grey' }}>
															{i.Destination_City}
														</span>
													</Box>
												</Box>
											</Box>
											<Box
												style={{
													backgroundColor: '#E1E1E1',
													color: 'rgba(0,0,0,.64)',
													padding: 10,
													display: 'flex',
													justifyContent: 'space-between',
												}}>
												<Box>
													<span style={{ fontSize: 14 }}>BAGGAGE</span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${i.Origin} to ${i.Destination}`}</span>
												</Box>
												<Box>
													<span style={{ fontSize: 14 }}>CHECK-IN </span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Check_In_Baggage}`}</span>
												</Box>
												<Box>
													<span style={{ fontSize: 14 }}>CABIN</span>
													<br />
													<span
														style={{
															fontSize: 16,
															color: 'black',
														}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Hand_Baggage}`}</span>
												</Box>
											</Box>
										</Box>
									);
								})}
							{location?.state?.onward?.Supplier === 'AIQ' && (
								<Box
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,.3)',
										backgroundColor: '#FFF',
										marginTop: 20,
										// padding: 10,
									}}>
									<Box
										style={{
											backgroundColor: '#E1E1E1',
											color: 'rgba(0,0,0,.64)',
											padding: 10,
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<Box
											style={{
												display: 'flex',
												alignItems: 'center',
											}}>
											<img
												src={`https://nitish.musafirbazar.com/static/media/${
													location?.state?.onward.flight_number.split(' ')[0]
												}.gif`}
												style={{ height: 35 }}
											/>
											<span style={{ fontSize: 14, marginLeft: 10 }}>
												{`${location?.state?.onward.airline} ${
													location?.state?.onward.flight_number.split(' ')[0]
												}-${
													location?.state?.onward.flight_number.split(' ')[1]
												}`}
											</span>
										</Box>
										{/* <span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span> */}
									</Box>

									<Box
										style={{
											padding: 20,
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<Box>
											<Box style={{ display: 'flex', alignItems: 'center' }}>
												<h1>{location?.state?.onward.origin}</h1>
												<span style={{ fontSize: '24px', marginLeft: '12px' }}>
													{location?.state?.onward.departure_time}
												</span>
											</Box>
											<Box>
												<span style={{ fontSize: 12, color: 'grey' }}>
													{location?.state?.onward.departure_date}
												</span>
												<br />
												<span style={{ fontSize: 12, color: 'grey' }}>
													{/* {i.Origin.Airport.AirportName} */}
												</span>
												<br />
												<span style={{ fontSize: 12, color: 'grey' }}>
													{/* {i.Origin.Airport.CityName} */}
												</span>
											</Box>
										</Box>
										<Box>
											<Box
												style={{ alignItems: 'center', textAlign: 'center' }}>
												<AccessTimeIcon />
												<h2>2hr 30mn</h2>
											</Box>
										</Box>
										<Box>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'end',
												}}>
												<h1>{location?.state?.onward.destination}</h1>
												<span style={{ fontSize: '24px', marginLeft: '12px' }}>
													{location?.state?.onward.arival_time}
												</span>
											</Box>
											<Box style={{ textAlign: 'end' }}>
												<span style={{ fontSize: 12, color: 'grey' }}>
													{location?.state?.onward.arival_date}
												</span>
												<br />
												<span style={{ fontSize: 12, color: 'grey' }}>
													{/* {i.Destination.Airport.AirportName} */}
												</span>
												<br />
												<span style={{ fontSize: 12, color: 'grey' }}>
													{/* {i.Destination.Airport.CityName} */}
												</span>
											</Box>
										</Box>
									</Box>
									{/* <Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<Box>
										<span style={{ fontSize: 14 }}>BAGGAGE</span>
										<br />
										<span
											style={{
												fontSize: 16,
												color: 'black',
											}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
									</Box>
									<Box>
										<span style={{ fontSize: 14 }}>CHECK-IN </span>
										<br />
										<span
											style={{
												fontSize: 16,
												color: 'black',
											}}>{`${i.Baggage}`}</span>
									</Box>
									<Box>
										<span style={{ fontSize: 14 }}>CABIN</span>
										<br />
										<span
											style={{
												fontSize: 16,
												color: 'black',
											}}>{`${i.CabinBaggage}`}</span>
									</Box>
								</Box> */}
								</Box>
							)}
							{location?.state?.return?.Segments[0]?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
												</span>
											</Box>
											<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1>{i.Origin.Airport.AirportCode}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Origin.DepTime.split('T')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.DepTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.CityName}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1>{i.Destination.Airport.AirportCode}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Destination.ArrTime.split('T')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.ArrTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.CityName}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Baggage}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.CabinBaggage}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
									// padding: 10,
								}}>
								{location?.state?.passengerData?.adult?.map((f) => {
									return (
										<Box
											style={{
												marginTop: 20,
												border: '1px solid lightgrey',
												padding: 20,
											}}>
											<Box
												style={{
													display: 'flex',
													justifyContent: 'space-between',
												}}>
												<Box style={{ display: 'flex' }}>
													<svg
														focusable='false'
														color='inherit'
														fill='none'
														aria-hidden='true'
														role='presentation'
														viewBox='0 0 20 21'
														preserveAspectRatio='xMidYMid meet'
														width='24px'
														height='24px'
														class='sc-hMqMXs llihTZ'>
														<path
															d='M10 0.75C8.07164 0.75 6.18657 1.32183 4.58319 2.39317C2.97982 3.46452 1.73013 4.98726 0.992179 6.76884C0.254224 8.55042 0.061142 10.5108 0.437348 12.4021C0.813554 14.2934 1.74215 16.0307 3.10571 17.3943C4.46927 18.7579 6.20656 19.6865 8.09787 20.0627C9.98919 20.4389 11.9496 20.2458 13.7312 19.5078C15.5127 18.7699 17.0355 17.5202 18.1068 15.9168C19.1782 14.3134 19.75 12.4284 19.75 10.5C19.747 7.91506 18.7188 5.43684 16.891 3.60901C15.0632 1.78118 12.5849 0.752988 10 0.75ZM14.6436 8.79272L9.14307 14.0427C9.00322 14.1758 8.81756 14.25 8.62452 14.25C8.43147 14.25 8.24582 14.1758 8.10596 14.0427L5.35645 11.4177C5.2128 11.2801 5.12965 11.0911 5.12524 10.8923C5.12084 10.6934 5.19555 10.5009 5.33297 10.3571C5.47038 10.2133 5.65927 10.1299 5.85813 10.1252C6.05699 10.1206 6.24956 10.195 6.39356 10.3323L8.62452 12.4629L13.6064 7.70728C13.7504 7.57004 13.943 7.49558 14.1419 7.50023C14.3407 7.50489 14.5296 7.58828 14.667 7.7321C14.8045 7.87592 14.8792 8.06841 14.8748 8.26727C14.8704 8.46614 14.7872 8.65513 14.6436 8.79272Z'
															fill='#319E37'></path>
													</svg>

													<div
														style={{
															marginLeft: 5,
														}}>{`${f.title} ${f.firstname} ${f.lastname} (Adults)`}</div>
												</Box>
											</Box>
										</Box>
									);
								})}
								{location?.state?.passengerData?.child?.map((f) => {
									return (
										<Box
											style={{
												marginTop: 20,
												border: '1px solid lightgrey',
												padding: 20,
											}}>
											<Box
												style={{
													display: 'flex',
													justifyContent: 'space-between',
												}}>
												<Box style={{ display: 'flex' }}>
													<svg
														focusable='false'
														color='inherit'
														fill='none'
														aria-hidden='true'
														role='presentation'
														viewBox='0 0 20 21'
														preserveAspectRatio='xMidYMid meet'
														width='24px'
														height='24px'
														class='sc-hMqMXs llihTZ'>
														<path
															d='M10 0.75C8.07164 0.75 6.18657 1.32183 4.58319 2.39317C2.97982 3.46452 1.73013 4.98726 0.992179 6.76884C0.254224 8.55042 0.061142 10.5108 0.437348 12.4021C0.813554 14.2934 1.74215 16.0307 3.10571 17.3943C4.46927 18.7579 6.20656 19.6865 8.09787 20.0627C9.98919 20.4389 11.9496 20.2458 13.7312 19.5078C15.5127 18.7699 17.0355 17.5202 18.1068 15.9168C19.1782 14.3134 19.75 12.4284 19.75 10.5C19.747 7.91506 18.7188 5.43684 16.891 3.60901C15.0632 1.78118 12.5849 0.752988 10 0.75ZM14.6436 8.79272L9.14307 14.0427C9.00322 14.1758 8.81756 14.25 8.62452 14.25C8.43147 14.25 8.24582 14.1758 8.10596 14.0427L5.35645 11.4177C5.2128 11.2801 5.12965 11.0911 5.12524 10.8923C5.12084 10.6934 5.19555 10.5009 5.33297 10.3571C5.47038 10.2133 5.65927 10.1299 5.85813 10.1252C6.05699 10.1206 6.24956 10.195 6.39356 10.3323L8.62452 12.4629L13.6064 7.70728C13.7504 7.57004 13.943 7.49558 14.1419 7.50023C14.3407 7.50489 14.5296 7.58828 14.667 7.7321C14.8045 7.87592 14.8792 8.06841 14.8748 8.26727C14.8704 8.46614 14.7872 8.65513 14.6436 8.79272Z'
															fill='#319E37'></path>
													</svg>

													<div
														style={{
															marginLeft: 5,
														}}>{`${f.title} ${f.firstname} ${f.lastname} (Child)`}</div>
												</Box>
											</Box>
										</Box>
									);
								})}
								{location?.state?.passengerData?.infant?.map((f) => {
									return (
										<Box
											style={{
												marginTop: 20,
												border: '1px solid lightgrey',
												padding: 20,
											}}>
											<Box
												style={{
													display: 'flex',
													justifyContent: 'space-between',
												}}>
												<Box style={{ display: 'flex' }}>
													<svg
														focusable='false'
														color='inherit'
														fill='none'
														aria-hidden='true'
														role='presentation'
														viewBox='0 0 20 21'
														preserveAspectRatio='xMidYMid meet'
														width='24px'
														height='24px'
														class='sc-hMqMXs llihTZ'>
														<path
															d='M10 0.75C8.07164 0.75 6.18657 1.32183 4.58319 2.39317C2.97982 3.46452 1.73013 4.98726 0.992179 6.76884C0.254224 8.55042 0.061142 10.5108 0.437348 12.4021C0.813554 14.2934 1.74215 16.0307 3.10571 17.3943C4.46927 18.7579 6.20656 19.6865 8.09787 20.0627C9.98919 20.4389 11.9496 20.2458 13.7312 19.5078C15.5127 18.7699 17.0355 17.5202 18.1068 15.9168C19.1782 14.3134 19.75 12.4284 19.75 10.5C19.747 7.91506 18.7188 5.43684 16.891 3.60901C15.0632 1.78118 12.5849 0.752988 10 0.75ZM14.6436 8.79272L9.14307 14.0427C9.00322 14.1758 8.81756 14.25 8.62452 14.25C8.43147 14.25 8.24582 14.1758 8.10596 14.0427L5.35645 11.4177C5.2128 11.2801 5.12965 11.0911 5.12524 10.8923C5.12084 10.6934 5.19555 10.5009 5.33297 10.3571C5.47038 10.2133 5.65927 10.1299 5.85813 10.1252C6.05699 10.1206 6.24956 10.195 6.39356 10.3323L8.62452 12.4629L13.6064 7.70728C13.7504 7.57004 13.943 7.49558 14.1419 7.50023C14.3407 7.50489 14.5296 7.58828 14.667 7.7321C14.8045 7.87592 14.8792 8.06841 14.8748 8.26727C14.8704 8.46614 14.7872 8.65513 14.6436 8.79272Z'
															fill='#319E37'></path>
													</svg>

													<div
														style={{
															marginLeft: 5,
														}}>{`${f.title} ${f.firstname} ${f.lastname} (Infant)`}</div>
												</Box>
											</Box>
										</Box>
									);
								})}
							</Box>
							{matches ? (
								<>
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
											}}>
											<span>Fare Summary</span>
										</Box>
										<Box
											style={{
												padding: 10,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}>
											<span style={{ fontSize: 12 }}>Fare Type</span>
											<span style={{ fontSize: 12, marginLeft: 10 }}>
												Partially Refundable
											</span>
										</Box>
										<Box
											style={{
												padding: 10,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}>
											<span style={{ fontSize: 12 }}>Base Fare</span>
											<span style={{ fontSize: 12, marginLeft: 10 }}>
												₹25150
											</span>
										</Box>
									</Box>
								</>
							) : (
								''
							)}
							<article class='card'>
								<div class='card-title'>
									<h2 style={{ fontSize: 24 }}>Payment</h2>
								</div>
								<div class='card-body'>
									<div class='payment-type'>
										<h4 style={{ marginTop: 12 }}>
											Choose payment method below
										</h4>
										<div
											class='types flex justify-space-between'
											style={{ marginTop: 10 }}>
											<div class='type selected'>
												<div class='logo'>
													<i class='fas fa-wallet'></i>
												</div>
												<div class='text'>
													<p>Pay with OFFLINE</p>
												</div>
											</div>
											{/* <div class='type'>
											<div class='logo'>
												<i class='fab fa-paypal'></i>
											</div>
											<div class='text'>
												<p>Pay with PayPal</p>
											</div>
										</div>
										<div class='type'>
											<div class='logo'>
												<i class='fab fa-amazon'></i>
											</div>
											<div class='text'>
												<p>Pay with Amazon</p>
											</div>
										</div> */}
										</div>
									</div>
								</div>
							</article>

							<Grid container style={{ marginBottom: 50 }}>
								<Grid item xs={3}></Grid>
								<Grid item xs={6}>
									<Button
										// onClick={() =>

										// }
										type='submit'
										style={{
											background: 'rgb(239, 64, 80)',
											color: 'white',
											width: '100%',
											marginTop: 30,
											padding: 16,
											borderRadius: 12,
										}}>
										Continue to final details
									</Button>
								</Grid>
								<Grid item xs={3}></Grid>
							</Grid>
						</Grid>
						<Grid item xs={12} lg={4}>
							{matches ? (
								''
							) : (
								<Box
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,.3)',
										backgroundColor: '#FFF',
										marginTop: 20,
										// padding: 10,
									}}>
									<Box
										style={{
											backgroundColor: '#E1E1E1',
											color: 'rgba(0,0,0,.64)',
											padding: 10,
										}}>
										<span>Fare Summary</span>
									</Box>
									<Box
										style={{
											padding: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<span style={{ fontSize: 12 }}>Fare Type</span>
										<span style={{ fontSize: 12, marginLeft: 10 }}>
											Partially Refundable
										</span>
									</Box>
									<Box
										style={{
											padding: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<span style={{ fontSize: 12 }}>Base Fare</span>
										<span style={{ fontSize: 12, marginLeft: 10 }}>₹25150</span>
									</Box>
								</Box>
							)}
						</Grid>
					</Grid>
				</Container>
				<Footer />
			</Watermark>
		</>
	);
};

export default FlightConfirmDetailPage;
